module.exports = __webpack_public_path__ + "static/media/hdi-off-app-provider-icon.76c0e907.svg";